import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";

// Face-ID admin login has been removed. Admins now sign in through the normal
// /signin route with email + password; SignIn routes role==="admin" straight to
// the dashboard. This component only exists to keep old /admin/login links working:
// it forwards admins to the dashboard and everyone else to /signin.
const AdminLogin = () => {
  const navigate = useNavigate();
  const { user, loading } = useApp();

  useEffect(() => {
    if (loading) return;
    if (user?.role === "admin") navigate("/admin/dashboard", { replace: true });
    else navigate("/signin", { replace: true });
  }, [user, loading, navigate]);

  return null;
};

export default AdminLogin;
